import { render, staticRenderFns } from "./ownerregister.vue?vue&type=template&id=13903e58&scoped=true&"
import script from "./ownerregister.vue?vue&type=script&lang=js&"
export * from "./ownerregister.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/login.css?vue&type=style&index=0&id=13903e58&scoped=true&lang=css&"
import style1 from "./ownerregister.vue?vue&type=style&index=1&id=13903e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13903e58",
  null
  
)

export default component.exports